export default {
  readMore: {
    id: 'rm_article_tile_read_more',
    defaultMessage: 'Read More',
  },
  readLabel: {
    id: 'rm_article_tile_read_label',
    defaultMessage: 'Read the story: {title}',
  },
} as const
